import React from 'react';

const Catalog = () => {
  return (
    <div className="catalog">
      <h1>Catalog</h1>
      <div className="catalog-content">
        {/* Catalog content will go here */}
      </div>
    </div>
  );
};

export default Catalog; 